export default "__VITE_ASSET__CvrzRYXi__"